'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CheckListItem = exports.CheckList = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _prefix = require('../../utils/prefix');

var _prefix2 = _interopRequireDefault(_prefix);

require('./styles.sass');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var modifiers = (0, _prefix2.default)('checklist-item--');

var CheckList = exports.CheckList = function CheckList(_ref) {
  var children = _ref.children;
  return _react2.default.createElement(
    'div',
    { className: 'checklist' },
    children
  );
};

CheckList.propTypes = {
  children: _propTypes2.default.node
};

var CheckListItem = exports.CheckListItem = function CheckListItem(_ref2) {
  var onChange = _ref2.onChange,
      small = _ref2.small,
      checked = _ref2.checked,
      children = _ref2.children;
  return _react2.default.createElement(
    'div',
    {
      className: (0, _classnames2.default)('checklist-item', modifiers({ checked: checked, small: small })),
      role: 'checkbox',
      'aria-checked': checked,
      onClick: function onClick() {
        return onChange && onChange(!checked);
      }
    },
    _react2.default.createElement(
      'span',
      { className: 'checklist-item__label' },
      children
    )
  );
};

CheckListItem.propTypes = {
  onChange: _propTypes2.default.func,
  checked: _propTypes2.default.bool,
  small: _propTypes2.default.bool,
  children: _propTypes2.default.node
};
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@taxfyle/web-commons/lib/components/CheckList/index.js
// module id = 150
// module chunks = 0